export default function Footer() {
  return (
    <footer
      className="bg-ink text-paper/70 py-14"
      data-testid="site-footer"
    >
      <div className="max-w-screen-2xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 border-b border-paper/15 pb-10">
          <div className="flex items-center gap-4">
            <img src="/logo.png" alt="The Art Lounge Nirvana" className="h-12 w-auto brightness-0 invert opacity-90" />
            <div>
              <p className="font-serif text-3xl md:text-4xl text-paper tracking-tight leading-none">
                Aparna Banerjee
              </p>
              <p className="font-body text-[11px] tracking-[0.35em] uppercase text-ochre mt-2">
                The Art Lounge Nirvana
              </p>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              ["Collection", "#collection"],
              ["Sacred Wild", "#sacred-wild"],
              ["Studio", "#studio"],
              ["Projects", "#projects"],
              ["Kenya", "#exhibition"],
              ["The Artist", "#artist"],
              ["Press", "#testimonials"],
              ["Visit", "#contact"],
            ].map(([label, href]) => (
              <a
                key={href}
                href={href}
                className="font-body text-[12px] tracking-[0.18em] uppercase text-paper/60 hover:text-ochre transition-colors"
                data-testid={`footer-${label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {label}
              </a>
            ))}
          </nav>
        </div>
        <div className="flex flex-col md:flex-row justify-between gap-4 pt-8 font-body text-xs text-paper/50">
          <p>&copy; {new Date().getFullYear()} Aparna Banerjee. All works are original and copyright of the artist.</p>
          <p>Gurugram, India &middot; theartlounge.nirvana@gmail.com</p>
        </div>
      </div>
    </footer>
  );
}
